import { SentryEnvironment } from '@techniek-team/sentry-web';
import { EnvironmentModel } from './environment.model';

const baseAppUrl: string = 'https://alfred-web.kube.techniek-team.nl/';

export const environment: EnvironmentModel = {
  production: false,
  environment: SentryEnvironment.ACCEPTANCE,
  release: '4.2.0-develop.1',
  sentryDsn:
    'https://103363a1242344fbbcbf224e95f133df@errors.techniek-team.nl/114',
  alfredApiUrl: 'https://ly-al-api.acc.techniek-team.nl',
  biebApiUrl: 'https://lyceo-bieb.kube.techniek-team.nl',
  authConfig: {
    issuer: 'https://login.kube.techniek-team.nl/realms/sso',
    clientId: 'alfred-web-acceptance',
    responseType: 'code',
    redirectUri: baseAppUrl + 'home',
    postLogoutRedirectUri: baseAppUrl + 'home',
    scope: 'openid profile email offline_access',
    showDebugInformation: false,
    clearHashAfterLogin: true,
    nonceStateSeparator: 'semicolon',
  },
  authModuleConfig: {
    resourceServer: {
      allowedUrls: [
        'https://ly-al-api.acc.techniek-team.nl',
        'https://lyceo-bieb.kube.techniek-team.nl',
      ],
      sendAccessToken: true,
    },
  },
};
